import * as React from 'react';
import { Grid, GridColumn, IButtonProps, Icon, List, ListItem, Table } from 'telia-front-react';

import ButtonWithAnalytics from '../components/common/ButtonWithAnalytics';

export interface ITemplateBillingSettingsDesktopProps {
  /**
   * Bills table labels.
   */
  labels: ITemplateBillingSettingsDesktopLabels;
  /**
   * Bills data.
   */
  bills?: ITemplateBillingSettingsDesktopBill[];
}

export interface ITemplateBillingSettingsDesktopBill {
  icon: string;

  serviceTitle: string;

  referenceNumber: string;

  settingsButton: IButtonProps;

  deliveryChannels: ITemplateBillingSettingsDesktopDeliveryChannel[];
}

export interface ITemplateBillingSettingsDesktopDeliveryChannel {
  title: string;

  description?: string;
}

export interface ITemplateBillingSettingsDesktopLabels {
  title: string;

  delivery: string;
}

export default class TemplateBillingSettingsDesktop extends React.Component<ITemplateBillingSettingsDesktopProps> {
  public renderBillRow(bills: ITemplateBillingSettingsDesktopBill[]): JSX.Element[] {
    return bills.map((bill: ITemplateBillingSettingsDesktopBill, index: number) => (
      <tr key={index} id={`invoice-settings-card-row-${index}`}>
        <td id={`invoice-settings-card-row-${index}-column-0`}>
          <Grid noWrap={true} align={['middle-xs']} verticalGutter="none">
            <GridColumn width={['min']}>{this.renderIcon(bill)}</GridColumn>
            <GridColumn width={['max']}>
              <div id={`invoice-settings-card-row-service-title-${index}`} className="text-bold">
                {bill.serviceTitle}
              </div>
              <div id={`invoice-settings-card-row-reference-number-${index}`} className="text-light">
                {bill.referenceNumber}
              </div>
            </GridColumn>
          </Grid>
        </td>
        <td>{this.renderDeliveryChannels(bill.deliveryChannels, index)}</td>
        {bill.settingsButton ? <td data-headless={true}>{this.renderButton(bill, `invoice-settings-card-settings-button-${index}`)}</td> : <React.Fragment />}
      </tr>
    ));
  }

  public renderDeliveryChannels(deliveryChannels: ITemplateBillingSettingsDesktopDeliveryChannel[], parentIndex: number): JSX.Element {
    const channels = deliveryChannels.map((deliveryChannel, index) => (
      <ListItem key={index}>
        <div id={`invoice-settings-card-row-delivery-channel-title-${parentIndex}-${index}`}>{deliveryChannel.title}</div>
        {deliveryChannel.description && (
          <div className="text-light text-small" id={`invoice-settings-card-row-delivery-channel-description-${parentIndex}-${index}`}>
            {deliveryChannel.description}
          </div>
        )}
      </ListItem>
    ));

    return <List type="unstyled">{channels}</List>;
  }

  public renderIcon(bill: ITemplateBillingSettingsDesktopBill): JSX.Element {
    return <Icon size="sm" modifiers={bill.icon} />;
  }

  public renderButton(bill: ITemplateBillingSettingsDesktopBill, buttonId: string): JSX.Element {
    return (
      <Grid align={['end-xs']} gutter="none">
        <GridColumn width={['xs']}>
          <ButtonWithAnalytics
            gaEvent="CTA - Form - invoice settings"
            buttonProps={{
              id: buttonId,
              size: 'small',
              type: 'primary',
              iconRight: '#arrow-right',
              ...bill.settingsButton
            }}
          />
        </GridColumn>
      </Grid>
    );
  }

  public render(): JSX.Element {
    const { bills, labels } = this.props;

    return (
      <Table responsive="cols" break="md">
        <thead>
          <tr>
            <th>{labels.title}</th>
            <th>{labels.delivery}</th>
            <th />
          </tr>
        </thead>
        <tbody>{bills && this.renderBillRow(bills)}</tbody>
      </Table>
    );
  }
}
